module.exports = __webpack_public_path__ + "static/pic02-444f4da8b4c7f3ab41684e88eaeb7d02.jpg";